/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Copy_Id_Success_ToastInputs */

const en_explorer_info_copy_id_success_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID copied to clipboard`)
};

const fr_explorer_info_copy_id_success_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID copie dans le presse-papiers`)
};

const de_explorer_info_copy_id_success_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID in die Zwischenablage kopiert`)
};

const it_explorer_info_copy_id_success_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID copiato negli appunti`)
};

const ru_explorer_info_copy_id_success_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор скопирован в буфер обмена`)
};

const es_explorer_info_copy_id_success_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID copiado al portapapeles`)
};

const zh_cn2_explorer_info_copy_id_success_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID已复制到剪贴板`)
};

const ja_explorer_info_copy_id_success_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDをクリップボードにコピーしました`)
};

const hi_explorer_info_copy_id_success_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आईडी क्लिपबोर्ड पर कॉपी हो गई`)
};

const pt_pt2_explorer_info_copy_id_success_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID copiado para a área de transferência`)
};

/**
* | output |
* | --- |
* | "ID copied to clipboard" |
*
* @param {Explorer_Info_Copy_Id_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_copy_id_success_toast = /** @type {((inputs?: Explorer_Info_Copy_Id_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Copy_Id_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_copy_id_success_toast(inputs)
	if (locale === "de") return de_explorer_info_copy_id_success_toast(inputs)
	if (locale === "it") return it_explorer_info_copy_id_success_toast(inputs)
	if (locale === "ru") return ru_explorer_info_copy_id_success_toast(inputs)
	if (locale === "es") return es_explorer_info_copy_id_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_copy_id_success_toast(inputs)
	if (locale === "ja") return ja_explorer_info_copy_id_success_toast(inputs)
	if (locale === "hi") return hi_explorer_info_copy_id_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_copy_id_success_toast(inputs)
	return en_explorer_info_copy_id_success_toast(inputs)
});